import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2","key":"svg-0"}]]

/**
 * IconPhone
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGhvbmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgNGg0bDIgNWwtMi41IDEuNWExMSAxMSAwIDAgMCA1IDVsMS41IC0yLjVsNSAydjRhMiAyIDAgMCAxIC0yIDJhMTYgMTYgMCAwIDEgLTE1IC0xNWEyIDIgMCAwIDEgMiAtMiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/phone
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPhone = createReactComponent('outline', 'phone', 'Phone', __iconNode);

export default IconPhone;